<template>
  <div class="swiper-base" v-if="HomeBanner">
    <el-carousel class="swiper" height="90.4vh">
      <el-carousel-item v-for="(item,index) in HomeBanner.photoList" :key="index" class="swiper-item">
        <el-image :src="'http://'+item.address" class="swiper-image"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "HomeSwiper",
  props:{
    HomeBanner:{
      default(){
        return {}
      }
    }
  },
  data(){
    return{

    }
  }
}
</script>

<style lang="less" scoped>
.swiper-item{
  .swiper-image{
    width: 100%;
    height: 100%;
  }
}

</style>